<template>
  <div class="hello">
     <div class="center">
    <el-form :inline="true" :model="gameOptions" v-if="!isStarted">

        <el-form-item label="Width:">
            <el-select v-model="gameOptions.width">
                <el-option v-for="n in 10" :key="n" :value="n+4" :label="n+4"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Height:">
            <el-select v-model="gameOptions.height">
                <el-option v-for="n in 10" :key="n" :value="n+4" :label="n+4"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Walls:">
            <el-select v-model="gameOptions.walls">
                <el-option v-for="n in 10" :key="n" :value="n+4" :label="n+4"></el-option>
            </el-select>
        </el-form-item>
        
        
        <el-form-item>
            <el-button type="primary" @click="startButtonOnClick">Start</el-button>
        </el-form-item>
    </el-form>
</div> 
    <!-- <div v-if="!isStarted">
        <span>Width:</span>
        <select v-model="boardWidth">
            <option v-for="n in 10" :key="n">{{n+4}}</option>
        </select>
        <span>Height:</span>
        <select v-model="boardHeight">
            <option v-for="n in 10" :key="n">{{n+4}}</option>
        </select>
        <span>Walls:</span>
        <select v-model="walls">
            <option v-for="n in 10" :key="n">{{n+4}}</option>
        </select>
        <button @click="startButtonOnClick">Start</button>
    </div> -->
   
    <div v-if="isStarted" class="center gameInfo">
        <div>
           <span class="player1notation">●</span> Alice remain {{gameBoard.player1RemainWalls}} walls
        </div>
        <div tex>
           <span class="player2notation">●</span>  Bob remain {{gameBoard.player2RemainWalls}} walls
        </div>

        <div v-if="winner === 0">Current player: {{getPlayerName(gameBoard.toPlay)}} <span v-if="gameBoard.toPlay == 1" class="player1notation">●</span> <span v-else class="player2notation">●</span> </div>
        <div v-else>Winner: {{getPlayerName(winner)}} <span v-if="winner == 1" class="player1notation">●</span> <span v-else class="player2notation">●</span>  </div>

        <el-button @click="startFromBeginningButtonOnClick">Start From Beginning</el-button>
    </div>
    <el-divider></el-divider>
    <table id='board' v-if="isStarted">
        <tr v-for="(item, index) in gameBoard.gridIDS" :key="index+'row'">
            <td v-for="(gelem, jidx) in item" :key="index+'-'+jidx" 
                v-bind:class="[getGridClass(index, jidx), getUpdatingClass(index, jidx)]" 
                v-bind:data-pos="gelem.id"
                @mouseenter="moseEnterGridElem(index, jidx)"
                @mouseleave="mouseLeaveGridElem(index, jidx)"
                @click="clickOnGrid(index, jidx)"
            >
            <div class="piece1" v-if="gameBoard.isPlayer1InGrid(index, jidx)" @click="piece1OnClick"></div>
            <div class="piece2" v-if="gameBoard.isPlayer2InGrid(index, jidx)" @click="piece2OnClick"></div>
            </td>
        </tr>
    </table>
  </div>
</template>

<script>
import {Board, ElemState, ElemType} from './board'
export default {
    name: 'GameBoardView',
    data() {
        return {
            gameBoard: new Board(5, 5, 6),
            boardWidth: 7,
            boardHeight: 7,
            walls: 7,
            isStarted: false,
            gameOptions: {
                width: 7,
                height: 7,
                walls: 7,
            }
        }
    },
    computed: {
        winner() {
            return this.gameBoard.winner;
        }
    },
    watch: {
        winner() {
            if (this.winner !== 0) {
                alert(this.getPlayerName(this.gameBoard.winner) + " win!")
            }
        }
    },
    methods: {
        getPlayerName(player) {
            return player === 1 ? "Alice" : "Bob";
        },
        startButtonOnClick() {
            let width = parseInt(this.gameOptions.width);
            let height = parseInt(this.gameOptions.height);
            let walls = parseInt(this.gameOptions.walls)
            this.gameBoard = new Board(width, height, walls);
            this.isStarted = true;
        },
        startFromBeginningButtonOnClick() {
            this.isStarted = false;
        },
        getGridClass: function (idx, jidx) {
            let row = Math.trunc(idx/2);
            if (idx % 2 === 0) {
                if (jidx % 2 === 0) {
                    return "slot";
                } else {
                    if (row === this.gameBoard.height-1) {
                        return "wallPlacementVert_NOHOVER";
                    } else {
                        return "wallPlacementVert";
                    }
                }
            } else {
                if (jidx % 2 === 0) {
                    let col = Math.trunc(jidx/2);
                    if (col === this.gameBoard.width-1) {
                        return "wallPlacementHoriz_NOHOVER";
                    } else {
                        return "wallPlacementHoriz";
                    }
                } else {
                    return "crossSpace"
                }
            }
        },
        getUpdatingClass: function (idx, jidx) {
            if (this.gameBoard.gridIDS[idx][jidx].state === ElemState.Hover) {
                return "possibleWall";
            } else if (this.gameBoard.gridIDS[idx][jidx].state === ElemState.P1Block || this.gameBoard.gridIDS[idx][jidx].state === ElemState.P2Block) {
                return "keepWall";
            } else if (this.gameBoard.gridIDS[idx][jidx].type == ElemType.SLOT) {
                if (this.gameBoard.isShowingLealMoves(idx, jidx)!==0) {
                    return "movableGreenSpaces";
                }
            }
        },
        moseEnterGridElem: function(idx, jidx) {
            if (!this.gameBoard.canPutOnGridElement(idx, jidx)) {
                return
            }
            this.gameBoard.setNext3Edge(idx, jidx, ElemState.Hover);

        },
        mouseLeaveGridElem: function(idx, jidx) {
            if (this.gameBoard.gridIDS[idx][jidx].type == ElemType.HEDGE || this.gameBoard.gridIDS[idx][jidx].type == ElemType.VEDGE) {
                if (this.gameBoard.gridIDS[idx][jidx].type == ElemType.HEDGE) {
                    let col = Math.trunc(jidx/2);
                    if (col == this.gameBoard.width-1) {
                        return
                    }
                }
                if (this.gameBoard.gridIDS[idx][jidx].type == ElemType.VEDGE) {
                    let row = Math.trunc(idx/2);
                    if (row == this.gameBoard.height-1) {
                        return
                    }
                }
                if (this.gameBoard.gridIDS[idx][jidx].state != ElemState.Hover) {
                    return
                }
                this.gameBoard.setNext3Edge(idx, jidx, ElemState.Normal);
            }
        },
        clickOnGrid(idx, jidx) {
            if (this.winner !== 0) {
                return;
            }
            // click on the slot
            if (this.gameBoard.gridIDS[idx][jidx].type === ElemType.SLOT) {
                let player = this.gameBoard.isShowingLealMoves(idx, jidx);
                if (player === 0) {
                    return;
                }
                let row = Math.trunc(idx/2);
                let col = Math.trunc(jidx/2);
                this.gameBoard.movePlayer(row, col, player);
                return;
            }

            // click on the edge
            if (!this.gameBoard.canPutOnGridElement(idx, jidx)) {
                return;
            }
            let canPutWall = this.gameBoard.putOnWall(idx, jidx);
            if (!canPutWall) {
                alert("The wall is illegal!")
            }
        },
        piece1OnClick() {
            if (this.winner !== 0) {
                return;
            }
            if (this.gameBoard.isPlayer1ToPlay() == true) {
                this.gameBoard.updatePlayer1LegalMoves();
            }
        },
        piece2OnClick() {
            if (this.winner !== 0) {
                return;
            }
            if (this.gameBoard.isPlayer1ToPlay() == false) {
                this.gameBoard.updatePlayer2LegalMoves()
            }
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    :root {
        --var-player1-color: #d13131;
        --var-player2-color: #2da0ff;
    }
</style>

<style scoped>
.player1notation {
    color: var(--var-player1-color);
}
.player2notation {
    color: var(--var-player2-color);
}
.gameInfo {
    font-size: x-large;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}
#board {
    margin-left: auto;
    margin-right: auto;
}
#board td { width: 50px; height: 50px; border: 0px solid black; background: #fff; }
#board td.wallPlacementVert,
#board td.wallPlacementVert_NOHOVER { width: 11px; border: 0px; background: #7da4b4; }
#board td.wallPlacementHoriz,
#board td.wallPlacementHoriz_NOHOVER { height: 11px; border: 0px; background: #7da4b4; }     
#board td.crossSpace { width: 11px; height: 11px; border: 0px; background: #7da4b4; }
#board td.wallPlacementHoriz, #board td.wallPlacementVert { cursor: pointer; }
#board td.movableGreenSpaces { background: #f3ff6a; }    
/* WALL PLACEMENT */
#board td.possibleWall { background: #5f212d; }
#board td.keepWall { background: #5f212d; }
#showCompPieces, #showPlayerPieces { margin-top: 5px; }
#showPlayerPieces span, #showCompPieces span { font-size: 17px; font-family: "Arial"; margin-left: 18px; }
#showPlayerPieces span.wallVal, #showCompPieces span.wallVal { margin: 0; font-size: 24px; }
/* PIECES */
.piece1 { border-radius: 50%; width: 39px; height: 39px; background: var(--var-player1-color); margin-left: 5px; border: 1px solid var(--var-player1-color); }
.piece2 { border-radius: 50%; width: 39px; height: 39px; background: var(--var-player2-color); margin-left: 5px; border: 1px solid var(--var-player2-color); }
</style>
